/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/promotion.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopPay from '../student/_PopPay';

const Inquiry = () => {
  const [modalPay, setModalPay] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '미통화', value: 0},
    {title: '재전화 요청', value: 1},
    {title: '호의적', value: 2},
    {title: '관심없음', value: 3},
    {title: '불가', value: 4},
    {title: '차단', value: 5},
    {title: '시범강의 요청', value: 6},
    {title: '홍보책자 발송', value: 7}
  ];
  return (
    <main className="com_container p_pr_class">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_2">홈페이지 상담신청</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />

            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="110" />
                <col width="100" />
                <col width="110" />
                <col width="120" />
                <col width="100" />
                <col width="100" />
                <col width="auto" />
                <col width="90" />
                <col width="90" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>등록일</th>
                  <th>비고</th>
                  <th>전화번호</th>
                  <th>통화시간</th>
                  <th>통화 상태</th>
                  <th>상담가능 시간대</th>
                  <th>메모</th>
                  <th>홍보 책자</th>
                  <th>시범 강의</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>2023, 05, 20</td>
                  <td>12 : 30</td>
                  <td>010-1234-1324</td>
                  <td>
                    김홍보101 <br />
                    1시간 30분
                  </td>
                  <td>통화 불가</td>
                  <td>13시~17시</td>
                  <td>성격은 좋으나..</td>
                  <td>
                    <span className="btn_link red">요청중</span>
                  </td>
                  <td>
                    <span className="btn_link red">요청중</span>
                  </td>
                </tr>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>2023, 05, 20</td>
                    <td>12 : 30</td>
                    <td>010-1234-1324</td>
                    <td>
                      김홍보101 <br />
                      1시간 30분
                    </td>
                    <td>
                      <span className="com_blue_txt">재전화 요청</span>
                    </td>
                    <td>13시~17시</td>
                    <td>성격은 좋으나..</td>
                    <td>
                      <span className="btn_link blue">
                        발송
                        <br />
                        23.11.20
                      </span>
                    </td>
                    <td>
                      <span className="btn_link blue">
                        김담임101
                        <br />
                        23.11.20
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <Paging />
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">실시간 통화 내용</div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">등록일시</span>
                  <span className="cont bold">2023, 05, 23 ㅣ 15 : 30</span>
                </div>
                <div className="info">
                  <span className="tit">지역</span>
                  <span className="cont bold">서울/경기</span>
                </div>
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">김학생</span>
                </div>
                <div className="info">
                  <span className="tit">휴대폰 번호</span>
                  <span className="cont">010-1234-1234</span>
                </div>
                <div className="info">
                  <span className="tit">학년 / 계열</span>
                  <span className="cont">고1 / 인문</span>
                </div>
                <div className="info">
                  <span className="tit">학교명</span>
                  <span className="cont">서울 경기고등학교</span>
                </div>
                <div className="info">
                  <span className="tit">상담가능시간</span>
                  <span className="cont">오전10시 ~ 12시 </span>
                </div>
                <div className="info">
                  <span className="tit">유입경로</span>
                  <span className="cont">인터넷(온라인)을 통해 </span>
                </div>
              </div>

              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="cont ">김홍보 103 ㅣ 2023, 04, 22 ㅣ 10:30 ㅣ 1시간 30분</span>
                  </div>
                  <div className="info">
                    <span className="cont ">김홍보 103 ㅣ 2023, 04, 22 ㅣ 10:30 ㅣ 1시간 30분</span>
                  </div>
                  <div className="info">
                    <span className="cont ">김홍보 103 ㅣ 2023, 04, 22 ㅣ 10:30 ㅣ 1시간 30분</span>
                  </div>
                </div>
              </div>
            </div>

            <hr className="com_divider" />
            <div className="com_info">
              <p className="name">010-1234-4567 전화 수신 내역</p>
            </div>

            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">수신일시</span>
                  <span className="cont">2023, 05, 23 ㅣ 10:30 </span>
                </div>
                <div className="info">
                  <span className="tit">발신자 명</span>
                  <span className="cont">김아무개 </span>
                </div>
                <div className="info">
                  <span className="tit">수신자 명</span>
                  <span className="cont">김배정 101 </span>
                </div>
                <div className="info">
                  <span className="tit">내용</span>
                  <span className="cont">어쩌고 저쩌고 </span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">수신일시</span>
                  <span className="cont">2023, 05, 23 ㅣ 10:30 </span>
                </div>
                <div className="info">
                  <span className="tit">발신자 명</span>
                  <span className="cont">김아무개 </span>
                </div>
                <div className="info">
                  <span className="tit">수신자 명</span>
                  <span className="cont">김배정 101 </span>
                </div>
                <div className="info">
                  <span className="tit">내용</span>
                  <span className="cont">어쩌고 저쩌고 </span>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopPay open={modalPay} close={() => setModalPay(false)} />
    </main>
  );
};

export default Inquiry;
